import { DolfinParser } from './base'

export class OperatorsParser extends DolfinParser {
  private replacements: { [index: string]: string } = {
    '=': '==',
    not: '!',
    and: '&&',
    or: '||',
    then: '?',
    else: ':'
  }

  execute(formula: string): string {
    let pFormula = this.getTags(formula)
      .map(tag => this.replacements[tag] ?? tag)
      .join(' ')

    for (const operator of ['contains', 'startswith', 'endswith']) {
      pFormula = this.replaceRegexOperator(pFormula, operator)
    }

    return pFormula
  }

  private replaceRegexOperator(formula: string, operator: string) {
    const regex = new RegExp(`(('[^']*')\\s${operator}\\s'([^']+)')`, 'g')
    const matches = formula.matchAll(regex)

    for (const match of matches) {
      const escaped = match[3].replace(/([([.+*/'])/g, '\\\\$1')
      formula = formula.replace(
        match[0],
        `new RegExp('${operator === 'startswith' ? '^' : ''}${escaped}${
          operator === 'endswith' ? '$' : ''
        }', 'i').test(${match[2]})`
      )
    }

    return formula
  }
}
